import { render, staticRenderFns } from "./Personalization.vue?vue&type=template&id=523dbcda&scoped=true"
import script from "./Personalization.vue?vue&type=script&lang=js"
export * from "./Personalization.vue?vue&type=script&lang=js"
import style0 from "./Personalization.vue?vue&type=style&index=0&id=523dbcda&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523dbcda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('523dbcda')) {
      api.createRecord('523dbcda', component.options)
    } else {
      api.reload('523dbcda', component.options)
    }
    module.hot.accept("./Personalization.vue?vue&type=template&id=523dbcda&scoped=true", function () {
      api.rerender('523dbcda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Personalization.vue"
export default component.exports